import ApiService from "./ApiService";
import utilityService from "./utilityService";

const getAll = async () => {
  const url = "/GetAllExceptionCategoryRunCharge";

  try {
    const result = await ApiService.get(url);

    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const getOne = async (id) => {
  const url = `/GetExceptionCategoryRunCharge?Id=${id}`;
  try {
    const result = await ApiService.get(url);
    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const url =
    "/UpdateExceptionCategoryRunCharge?" + utilityService.queryString(data);

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to exception category run charge method",
    };
  }
};

const add = async (data) => {
  const url =
    "/AddExceptionCategoryRunCharge?" + utilityService.queryString(data);

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to add exception category run charge method",
    };
  }
};

const remove = async (id) => {
  debugger;
  const url = "/DeleteExceptionCategoryRunCharge?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to remove exception category run charge",
    };
  }
};

export default {
  getAll,
  getOne,
  update,
  add,
  remove,
};
